import React from "react";
import ProfilePic from "../assets/passport.jpg";
import { animate, motion } from "framer-motion";
import { animateSection } from "../utils/animateSection";

function About() {
  return (
    <section
      id="about"
      className="py-[20px] sm:pt-[30px] sm:pb-[100px] max-w-[900px]  text-white/25 flex flex-col justify-center mx-auto font-sfMonoRegular overflow-x-hidden"
    >
      <div className="about-heading w-fit flex flex-row  mt-[10px] mb-[40px] ">
        <div className="text-theme-green flex items-center text-[15px] sm:text-[20px]">
          01.{" "}
        </div>
        <h1 className="text-theme-gray-light min-w-fit ml-[10px] text-[26px] sm:text-[32px]  flex justify-center items-center font-calibreSemiBold fontFix">
          About Me{" "}
        </h1>
      </div>
      <div className="flex flex-col md:flex-row align-middle min-h-full text-[20px] font-calibreRegular text-theme-gray-deep font-medium ">
        <div className="">
          <p className="mb-4">
            I’m Pranshu Jain, a developer who began my journey in tech as a Full
            Stack Web Developer in 2020, inspired by Google Assistant. I quickly
            fell in love with coding and web development, crafting innovative
            and functional applications. Over time, my focus shifted to Machine
            Learning, AI, and Deep Networks. I’m currently pursuing an{" "}
            <span className="text-theme-green">
              M.Tech CSE with a
              specialization in Artificial Intelligence & Data Analytics (AI&DA)
            </span>
            . Previously, I contributed to the Sunbird ED project, where I
            worked on solving real-world problems to make a positive impact. I’m
            always eager to explore new technologies and push the boundaries of
            what’s possible, with the goal of creating solutions that make a
            meaningful difference.
          </p>
          <p className="mb-4">
            Here are a few technologies I’ve been working with recently:
          </p>
          <div className="recent-skills">
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              AI Agents{" "}
            </div>
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              NLP
            </div>
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              Deep Learning
            </div>
            <div className="recent-skills-skill relative mb-[10px] pl-[20px] font-sfMonoRegular text-[14px]">
              LLM
            </div>
          </div>
        </div>
        <div className="mx-auto mt-16 md:mt-0 ">
          <div className="md:ml-[55px] wrap-image w-[200px] md:w-[250px] lg:w-[300px]">
            <img src={ProfilePic} alt="profile pic" className="" />
          </div>
        </div>
      </div>
    </section>
  );
}

function animatedSection() {
  return animateSection(About);
}

export default animatedSection;
